import Component from '../core/Component'
import Highcharts from 'highcharts'

import dataAktiva from '../data/charts/aktiva'
import dataObrat from '../data/charts/obrat'
import dataKapital from '../data/charts/kapital'

export default class Chart extends Component {

    constructor($element) {
        super($element)
        this.$links = this.$element.find('a')
        this.id = this.$element.data('target')
        if (this.id == null) {
            console.warn('Data attr. with name of id is required.')
        }

        this.data = {
            dataAktiva,
            dataObrat,
            dataKapital
        }

        setTimeout(() => {
            this.graph = Component.getFromElement($(this.id))
        }, 10)

    }

    prepare() {
        var self = this
        this.$links.on('click', function () {
            var name = 'data' + $(this).attr('href').replace('#', '').charAt(0).toUpperCase() + $(this).attr('href').replace('#', '').slice(1)
            self.graph.setData(self.data[name])
            self.$links.parent().removeClass('is-active')
            $(this).parent().addClass('is-active')
        })


    }
}


// WEBPACK FOOTER //
// ./components/ChartControl.js